import { createContext, useContext } from "react";

/** Where the shared contacts, gift-links and cancel dialogs read and write one campaign. */
export interface CampaignEndpoints {
  /** Prefix of the contacts, gift-links and budget-history routes. */
  campaign: (campaignId: string) => string;
  /** The builder-shape campaign the contact email preview renders from. */
  draft: (campaignId: string) => string;
  /** The Cancel dialog's money breakdown. */
  cancelPreview: (campaignId: string) => string;
  /** The list query that shows the campaign's recipient count, refreshed after a contacts write. */
  listKey: readonly string[];
}

export const CLIENT_CAMPAIGN_ENDPOINTS: CampaignEndpoints = {
  campaign: (id) => `/campaigns/${id}`,
  draft: (id) => `/campaign-builder/campaigns/${id}`,
  cancelPreview: (id) => `/campaign-builder/campaigns/${id}/cancel-preview`,
  listKey: ["campaigns"],
};

/** GFG-358: the Campaign Manager's routes, gated for GFG staff and replacement-only on additions. */
export const ADMIN_CAMPAIGN_ENDPOINTS: CampaignEndpoints = {
  campaign: (id) => `/admin/campaigns/${id}`,
  draft: (id) => `/admin/campaigns/${id}/draft`,
  cancelPreview: (id) => `/admin/campaigns/${id}/cancel-preview`,
  listKey: ["admin", "campaigns"],
};

// The client's routes unless a screen provides others. Exported raw: the values are fixed.
export const CampaignEndpointsContext = createContext<CampaignEndpoints>(CLIENT_CAMPAIGN_ENDPOINTS);

export function useCampaignEndpoints(): CampaignEndpoints {
  return useContext(CampaignEndpointsContext);
}
